import { z } from "zod";

export const EngagementRatingSchema = z.enum(["Critical", "VeryLow", "Low", "Good", "VeryGood", "Great", "Amazing"]);
export type EngagementRating = z.infer<typeof EngagementRatingSchema>;

export const MAX_SCORE = 10;

export function rateScore(score: number | null | undefined): EngagementRating | null {
    if (score === null || score === undefined) {
        return null;
    }
    if (score < 3) {
        return "Critical";
    }
    if (score < 5) {
        return "VeryLow";
    }
    if (score < 6) {
        return "Low";
    }
    if (score < 7) {
        return "Good";
    }
    if (score < 8) {
        return "VeryGood";
    }
    if (score < 9) {
        return "Great";
    }

    return "Amazing";
}

export function rateParticipationBand(rate: number): EngagementRating {
    if (rate <= 49) {
        return "VeryLow";
    }
    if (rate <= 59) {
        return "Low";
    }
    if (rate <= 79) {
        return "Good";
    }
    if (rate <= 99) {
        return "VeryGood";
    }

    return "Amazing";
}

export const RATING_LABEL_KEY: Record<EngagementRating, string> = {
    Critical: "critical",
    VeryLow: "veryLow",
    Low: "low",
    Good: "good",
    VeryGood: "veryGood",
    Great: "great",
    Amazing: "amazing"
};
